<template>
  <div
    :infinite-scroll-delay="300"
    :infinite-scroll-immediate="false"
    :infinite-scroll-distance="220"
    v-infinite-scroll="load"
  >
    <Pos :content="accountInfo.user_name" />
    <div class="account-box">
      <img
        class="cover"
        :src="
          accountInfo.user_cover
            ? accountInfo.user_cover
            : 'https://pbs.twimg.com/profile_banners/1566463268/1470764371/600x200'
        "
      />
      <div class="base-info">
        <img
          class="avatar"
          :src="
            accountInfo.user_avatar
              ? accountInfo.user_avatar
              : 'https://pbs.twimg.com/profile_images/446356636710363136/OYIaJ1KK_200x200.png'
          "
        />

        <div style="margin-left: auto; margin-bottom: 40px">
          <a
            class="profile"
            href="javascript:;"
            @click="dialogFormVisible = true"
            v-if="
              Number($route.params.id) ===
              $store.state.userStore.userInfo.user_id
            "
            >Edit Profile</a
          >
          <FollowBtn :target-id="$route.params.id" v-else />
        </div>

        <p class="name">{{ accountInfo.user_name }}</p>
        <p class="account">{{ accountInfo.user_email }}</p>
        <p class="content">
          {{
            accountInfo.user_content
              ? accountInfo.user_content
              : "React is a JavaScript library for building user interfaces."
          }}
        </p>
        <div class="info-item">
          <span class="sex">
            <template v-if="accountInfo.user_sex === 1">
              <svg
                t="1635825662891"
                class="icon"
                viewBox="0 0 1026 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8832"
                width="16"
                height="16"
              >
                <path
                  d="M615.574815 0v102.108378h234.338728L615.574815 333.894398A383.927503 383.927503 0 1 0 690.113931 408.433514L921.89995 174.094785V408.433514h102.108379V0zM385.830963 918.975406a280.798041 280.798041 0 1 1 280.798041-280.798041A281.308583 281.308583 0 0 1 385.830963 918.975406z"
                  p-id="8833"
                  fill="#70a8d9"
                ></path>
              </svg>
              man
            </template>

            <template v-else-if="accountInfo.user_sex === 2">
              <svg
                t="1635825768650"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2904"
                width="16"
                height="16"
              >
                <path
                  d="M639.99904 0.001536a383.487425 383.487425 0 0 0-307.199539 614.399078l-51.199923 51.199924-142.847786-142.335787-72.703891 72.703891 144.895783 144.895783L0 951.808108 72.191892 1024l210.943683-210.943684 144.895783 144.895783 72.191892-72.191892-144.383784-145.407782 51.199923-51.199923A383.999424 383.999424 0 1 0 639.99904 0.001536z m0 665.599002A281.599578 281.599578 0 1 1 921.598618 384.00096a282.111577 282.111577 0 0 1-281.599578 281.599578z"
                  p-id="2905"
                  fill="#d4237a"
                ></path>
              </svg>
              woman
            </template>

            <template v-else>
              <svg
                t="1635842402594"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="15446"
                width="16"
                height="16"
              >
                <path
                  d="M861.622857 605.842286H586.605714V563.931429a282.697143 282.697143 0 0 0 233.033143-278.235429A284.013714 284.013714 0 0 0 536.356571 2.413714 284.013714 284.013714 0 0 0 253.074286 285.696 282.697143 282.697143 0 0 0 486.107429 563.931429v41.910857H211.236571a49.371429 49.371429 0 0 0-50.322285 50.322285c0 28.525714 21.796571 50.249143 50.322285 50.249143h274.870858v144.164572L402.285714 766.756571c-20.114286-20.114286-51.931429-20.114286-70.363428 0-20.114286 20.114286-20.114286 51.931429 0 70.436572l169.252571 169.252571c10.093714 10.093714 23.405714 15.140571 35.181714 15.140572 11.702857 0 25.161143-5.12 35.254858-15.140572l169.252571-169.252571c20.114286-20.114286 20.114286-51.931429 0-70.436572-20.114286-20.114286-51.931429-20.114286-70.363429 0L586.605714 850.651429V706.56h274.870857c28.525714 0 50.322286-21.869714 50.322286-50.322286a49.371429 49.371429 0 0 0-50.322286-50.322285zM355.254857 285.696a183.149714 183.149714 0 0 1 182.710857-182.710857 183.149714 183.149714 0 0 1 182.710857 182.710857c0 100.571429-82.139429 181.028571-181.028571 182.710857-103.862857-1.682286-184.32-82.139429-184.32-182.710857z"
                  p-id="15447"
                  fill="#8a8a8a"
                ></path>
              </svg>
              unknown
            </template>
          </span>

          <span class="date" v-if="accountInfo.create_time">
            <svg
              t="1635825839711"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12486"
              width="16"
              height="16"
            >
              <path
                d="M768 51.2V0h-102.4v51.2H358.4V0H256v51.2H0v972.8h1024V51.2z m-166.4 819.2h-102.4v-307.2h-76.8V460.8h179.2zM102.4 307.2V153.6h153.6v51.2h102.4V153.6h307.2v51.2h102.4V153.6h153.6v153.6z"
                p-id="12487"
                fill="#536471"
              ></path>
            </svg>
            Joined
            {{ accountInfo.create_time.replace(/\s.*/, "") }}
          </span>
        </div>
        <div class="follow-item">
          <span
            @click="
              $router.push(
                `/follow/${accountInfo.user_name}/${accountInfo.user_id}/following`
              )
            "
            ><strong>{{ accountInfo.user_following }}</strong> Following</span
          >
          <span
            @click="
              $router.push(
                `/follow/${accountInfo.user_name}/${accountInfo.user_id}/followers`
              )
            "
            ><strong>{{ accountInfo.user_followers }}</strong> Followers</span
          >
        </div>
      </div>
    </div>
    <el-tabs :stretch="true" v-model="tabsName" :before-leave="beforeLeave">
      <el-tab-pane label="Tweets" name="0">
        <CardItem :data-list="dataList" />
      </el-tab-pane>
      <el-tab-pane label="Tweets & replies" name="1"></el-tab-pane>
      <el-tab-pane label="Media" name="2"></el-tab-pane>
      <el-tab-pane label="Likes" name="3"></el-tab-pane>
    </el-tabs>

    <!-- 个人信息 -->
    <el-dialog
      width="700px"
      class="form-dialog"
      title="Edit Profile"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="formData" :rules="rules" ref="form" class="form-box">
        <el-form-item
          label="name"
          prop="user_name"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formData.user_name"
            placeholder="Please enter name"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="content"
          prop="user_content"
          :label-width="formLabelWidth"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="formData.user_content"
            placeholder="Please enter content"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="email"
          prop="user_email"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="formData.user_email"
            placeholder="Please enter email"
          ></el-input>
        </el-form-item>

        <el-form-item label="sex" prop="user_sex" :label-width="formLabelWidth">
          <el-radio-group v-model="formData.user_sex">
            <el-radio :label="1">man</el-radio>
            <el-radio :label="2">woman</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="cover"
          prop="user_cover"
          :label-width="formLabelWidth"
        >
          <el-upload
            class="cover-uploader"
            action="http://upload.qiniup.com/"
            accept="image/*"
            drag
            :data="uploadData"
            :show-file-list="false"
            :limit="1"
            :on-success="(response) => uploadSuccess(response, 'user_cover')"
            :before-upload="beforeUpload"
          >
            <img
              v-if="formData.user_cover"
              :src="formData.user_cover"
              class="cover"
            />
            <template v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drag the file here, or <em> click upload </em>
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="avatar"
          prop="user_avatar"
          :label-width="formLabelWidth"
        >
          <el-upload
            class="avatar-uploader"
            action="http://upload.qiniup.com/"
            accept="image/*"
            drag
            :data="uploadData"
            :show-file-list="false"
            :limit="1"
            :on-success="(response) => uploadSuccess(response, 'user_avatar')"
            :before-upload="beforeUpload"
          >
            <img
              v-if="formData.user_avatar"
              :src="formData.user_avatar"
              class="avatar"
            />
            <template v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drag the file here, or <em> click upload </em>
              </div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveProfile()">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crypto from "crypto";
import Pos from "@/components/Pos";
import FollowBtn from "@/components/FollowBtn";
import CardItem from "@/components/CardItem";
import { cardList } from "@/api/card";
import { userInfoById, userUpdateInfo } from "@/api/account";
import { qiniuToken } from "@/api/account";

export default {
  data() {
    return {
      tabsName: 0,
      page: 1,
      dataList: [],
      accountInfo: {},
      // 是否加载完毕
      isAll: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      // 上传用
      uploadData: {
        fname: "",
        key: "",
        token: "",
      },
      formData: {},
      rules: {
        user_name: [
          {
            required: true,
            message: "Please enter user name",
            trigger: "blur",
          },
          { min: 3, message: "Enter at least 3 characters", trigger: "blur" },
        ],
        user_content: [
          {
            required: true,
            message: "Please enter content",
            trigger: "blur",
          },
        ],
        user_email: [
          {
            required: true,
            message: "Please enter email",
            trigger: "blue",
          },
          {
            type: "email",
            message: "Please enter the correct email address",
            trigger: ["blur", "change"],
          },
        ],
        user_sex: [
          {
            required: true,
            message: "Please select sex",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (![1, 2].includes(Number(value))) {
                callback(new Error("Please select sex"));
              } else {
                callback();
              }
            },
          },
        ],
        user_cover: [
          {
            required: true,
            message: "Please upload cover",
            trigger: "change",
          },
        ],
        user_avatar: [
          {
            required: true,
            message: "Please upload avatar",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: { Pos, FollowBtn, CardItem },
  created() {
    this.__loadListData();
    this.__loadUserInfo();
    const userInfo = this.$store.state.userStore.userInfo;
    this.formData = { ...userInfo, old_user_name: userInfo.user_name };
  },
  methods: {
    // 当前用户信息
    async __loadUserInfo() {
      const { code, data, msg } = await userInfoById({
        user_id: this.$route.params.id,
      });

      if (code === 200) {
        this.accountInfo = data;
        console.log(data);
      } else {
        this.$message.error(msg);
      }
    },
    // 推文列表
    async __loadListData() {
      const { code, data } = await cardList({
        page: this.page,
        limit: 5,
      });

      if (code === 200 && data.length > 0) {
        this.dataList = [...this.dataList, ...data];
        this.isAll = false;
      } else {
        this.isAll = true;
      }
    },
    // tab切换前
    beforeLeave(activeName) {
      if (activeName !== "0") {
        this.$message.info("模块暂未开放");
        return false;
      }
    },
    // 推文无限加载
    load() {
      if (!this.isAll) {
        ++this.page;
        this.__loadListData();
      }
    },
    // 修改个人信息
    async saveProfile() {
      try {
        await this.$refs.form.validate();
        const { code, msg } = await userUpdateInfo(this.formData);
        if (code === 200) {
          this.$store.commit("setUserInfo", this.formData);
          this.$message.success("修改成功");
          this.dialogFormVisible = false;
        } else {
          this.$message.error({ message: msg, duration: 0 });
        }
      } catch (error) {
        console.error("校验失败");
        console.error(error);
      }
    },
    /**
     * 上传成功
     * @param {key:string;hash:string} response
     */
    uploadSuccess({ key }, type) {
      const baseUrl = "http://files.stars-mine.com/";
      this.formData = { ...this.formData, [type]: baseUrl + key };
      this.$refs.form.clearValidate(type);
    },
    // 获取token 上传前的hook
    async beforeUpload({ name, type }) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      const str = `${Date.now()}_${name}_${Math.random()}`;
      const md5 = crypto.createHash("md5");
      const fileName = md5.update(str).digest("hex");

      // key即为文件名
      this.uploadData.key = `99999/${year}/${month}/${day}/${fileName}.${type.replace(
        "image/",
        ""
      )}`;

      this.uploadData.fname = name;

      const {
        data: { token },
      } = await qiniuToken();

      this.uploadData.token = token;
    },
  },
};
</script>

<style lang="scss" scoped>
.account-box {
  .cover {
    display: block;
    width: 100%;
    height: 147px;
    object-fit: cover;
  }

  .base-info {
    margin: 16px;
    position: relative;
    display: flex;
    flex-direction: column;

    .avatar {
      width: 130px;
      height: 130px;
      position: absolute;
      top: -65px;
      left: 10px;
      border-radius: 50%;
      border: 5px solid #fff;
    }

    .profile {
      display: block;
      padding: 0 16px;
      line-height: 36px;
      border-radius: 999px;
      text-align: center;
      font-size: 15px;
      font-weight: 700;
      text-decoration: none;
      transition: background 300ms ease-in-out;
      color: rgb(15, 20, 25);
      border: 1px solid #cfd9de;

      &:hover {
        background-color: #e7e7e8;
      }
    }

    p.name {
      font-size: 20px;
      font-weight: 800;
      color: rgb(15, 20, 25);
      line-height: 24px;
    }

    p.account {
      color: rgb(83, 100, 113);
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
    }

    p.content {
      margin: 12px 0;
      font-weight: 400;
      color: rgb(15, 20, 25);
      font-size: 15px;
      line-height: 20px;
    }

    .info-item {
      display: flex;

      span {
        color: rgb(83, 100, 113);
        font-size: 14px;
        font-weight: 400;
        line-height: 12px;
        display: flex;
        align-items: center;
        margin-right: 24px;

        svg {
          margin: 0 6px 0 0;
        }
      }
    }

    .follow-item {
      margin: 12px 0;

      span {
        color: rgb(83, 100, 113);
        margin-right: 12px;
        font-size: 15px;
        font-weight: 400;
        line-height: 12px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }

        strong {
          font-weight: 700;
          color: rgb(15, 20, 25);
        }
      }
    }
  }
}

.form-dialog {
  // /deep/ .el-dialog__body {
  //   padding: 0;
  // }

  .form-box {
    width: 600px;

    // /deep/ .el-upload {
    //   width: 100%;
    //   height: 200px;

    //   & > .el-upload-dragger {
    //     width: 100%;
    //     height: 100%;
    //   }
    // }

    .avatar,
    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>